export default "__VITE_ASSET__34142745__"